import styled from 'styled-components';

interface StyledProps {
  checked: boolean;
  circle?: boolean;
  size?: number;
  $disabled: boolean;
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 3px;
`;

export const StyledCheck = styled.span<StyledProps>`
  display: block;
  width: ${({ size }) => size || 18}px;
  min-width: ${({ size }) => size || 18}px;
  height: ${({ size }) => size || 18}px;
  border: ${({ checked, $disabled, theme }) =>
    `solid 1px ${$disabled ? theme.checkbox.disabled : !checked ? theme.checkbox.border : theme.checkbox.checked}`};
  background: ${({ checked, $disabled, theme }) =>
    !checked ? theme.checkbox.empty : $disabled ? theme.checkbox.disabled : theme.checkbox.checked};
  border-radius: 2px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  ${({ circle }) => (circle ? 'border-radius: 16px;' : '')}
`;
